import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { GetState, Subscribe } from '../state/createState';
import { ControllerProps } from '../controller';
import { WidgetViewModel } from './viewModel';
import { subscribeToAgendaViewModel } from './agendaViewModel/agendaViewModel';
import { subscribeToTimeZoneViewModel } from './timeZoneViewModel/timeZoneViewModel';
import { subscribeToDatePickerViewModel } from './datePickerViewModel/datePickerViewModel';
import { subscribeToInitialLoaderViewModel } from './initialLoaderViewModel/initialLoaderViewModel';
import { subscribeToLoadMoreViewModel } from './loadMoreViewModel/loadMoreViewModel';

export type SetViewModel = (partialViewModel: Partial<WidgetViewModel>) => void;
export type ViewModelSubscription = (args: {
  subscribe: Subscribe;
  setViewModel: SetViewModel;
  flowAPI: ControllerFlowAPI;
  getState: GetState;
}) => void;

export const initViewModelSubscriptions = ({
  flowAPI,
  getState,
  viewModel,
  subscribe,
  setProps,
}: {
  flowAPI: ControllerFlowAPI;
  getState: GetState;
  viewModel: WidgetViewModel;
  subscribe: Subscribe;
  setProps: (props: ControllerProps) => void;
}) => {
  const setViewModel: SetViewModel = (partialViewModel) => {
    Object.assign(viewModel, partialViewModel);
    setProps({ viewModel: { ...viewModel } });
  };

  const args = {
    subscribe,
    setViewModel,
    flowAPI,
    getState,
  };

  subscribeToInitialLoaderViewModel(args);
  subscribeToAgendaViewModel(args);
  subscribeToTimeZoneViewModel(args);
  subscribeToDatePickerViewModel(args);
  subscribeToLoadMoreViewModel(args);
};
